import { twMerge } from 'tailwind-merge';

/** Shimmering placeholder block. Size it with width/height classes. */
export function Skeleton({ className }: { className?: string }) {
  return (
    <div
      aria-hidden
      className={twMerge(
        'rounded bg-gradient-to-r from-legal-100 via-legal-50 to-legal-100 bg-[length:200%_100%] animate-shimmer',
        className
      )}
    />
  );
}

/** N shimmer lines of decreasing width — stand-in for a paragraph/list. */
export function SkeletonText({ lines = 3, className }: { lines?: number; className?: string }) {
  const widths = ['w-2/3', 'w-1/2', 'w-3/4', 'w-2/5'];
  return (
    <div className={twMerge('space-y-3', className)} aria-hidden>
      {Array.from({ length: lines }, (_, i) => (
        <Skeleton key={i} className={`h-4 ${widths[i % widths.length]}`} />
      ))}
    </div>
  );
}

/** Card-shaped skeleton matching the standard Card look. */
export function SkeletonCard({ lines = 2, className }: { lines?: number; className?: string }) {
  return (
    <div
      className={twMerge('bg-white rounded-card border border-legal-200 p-5', className)}
      aria-hidden
    >
      <SkeletonText lines={lines} />
    </div>
  );
}
